<script lang="ts">
    import vm, { handleSaveTemplate } from '@journeys/Journeys.viewmodel';
    import ScrollableContainer from '@shared/components/ScrollableContainer.vue';

    // components
    import FluidButton from '@shared/components/FluidButton.vue';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import BSFormInputTextarea from '@shared/components/BSFormInputTextarea.vue';

    // assets
    // import { ArrowLeftSVG } from '@shared/assets/vector/ui/IconsUI'

    const component = {
        name: 'Menu_SaveTemplate',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    import { ref } from 'vue';

    const { activeJourney } = vm;
    const title = ref(activeJourney.Title);
    const description = ref(activeJourney.Description);
</script>

<template>
    <ScrollableContainer>
        <!--
		<div class="menu-quickaccess">
			<FluidButton :icon="ArrowLeftSVG" class="btn btn-default" @click="() => {}" />
		</div>
        -->

        <h2 class="h3">{{ $Resources.SaveAsTemplateHeading }}</h2>

        <BSFormInputText class="form-group" v-model="title" :label="$Resources.TitleLabel" :placeholder="$Resources.TitleLabel"></BSFormInputText>

        <BSFormInputTextarea
            class="form-group"
            v-model="description"
            :label="$Resources.DescriptionLabel"
            :placeholder="$Resources.DescriptionLabel"></BSFormInputTextarea>
    </ScrollableContainer>

    <div class="static-container bottom">
        <FluidButton
            class="btn btn-primary btn-block mv-xxs"
            :text="$Resources.SaveAsTemplateButton"
            @click="() => handleSaveTemplate(activeJourney.JourneyId as string, title, description)" />
    </div>
</template>

<style></style>
